import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";
import telematicsService from "../../api/telematics.service";

import XLSX from "xlsx";
import rules from "../../utils/rules";
import config from "../../../secrets/config";

// Optional Excel header rows, in emission order: each is written only when its
// filter field is set, and each bumps the data start row by one.
const exportFilterRows = [
  { field: "fromDate", label: "From Date:" },
  { field: "toDate", label: "To Date:" },
  { field: "contractNumber", label: "Equipment #/Equipment SN/Jobsite :" },
];

export default {
  name: "birch-equipment",
  components: { pageheader },
  data() {
    return {
      input: {},
      search: "",
      contractNumber: "",
      fromDate: "",
      toDate: "",
      status: "",
      customerDataList: [],
      excelListCust: [],
      excelHeaderCust: [],
      startrowCust: "",
      iscustomerDataLoading: false,
      showCustDialog: false,
      description: "",
      customerEquipmentName: "",
      contractor: "",
      startDate: "",
      endDate: "",
      menu5: false,
      menu6: false,
      equipmentId: "",
      editCustomerOwnedEquipmentDetails: false,
      configdata: config.ENABLE_ACCESS_CODE,
      locations: [],
      isconfirm: false,
      confirmaccessdialog: false,
      locationSearchFilter: null,
      loadinglocations: false,
      dateCheck: false,
      showdisable: false,
      dateErrorMsg: "",

      accessCodesList: [],
      accessHeaders: [
        { text: "Access Code Name", value: "description" },
        { text: "Access Code", value: "code" },
        { text: "Actions", value: "action" },
      ],
      enableDisableAccess: false,
      name: "",
      accessKeysLoading: false,
      displayAccessForm: false,
      selectedAccessAssetCustId: "",
      selectedAccessAssetCustName: "",
      isEditAccess: false,
      selectedAssetId: "",
      assetIdNew: "",
      isLockednew: false,
      headers: [
        { text: "Access Codes", value: "accesscodesview" },
        { text: "Equipment #", value: "equipmentId" },
        { text: "Equipment Name", value: "customerEquipmentName" },
        { text: "Equipment SN", value: "serialNumber" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        {
          text: "Estimated Battery Lifespan (days)",
          value: "estimatedBatteryLifespan",
        },
        { text: "Hours", value: "hours" },
        { text: "Customer Name", value: "contractor" },
        { text: "Date Out", value: "startDate" },

        { text: "Date Due", value: "endDate" },

        { text: "Jobsite", value: "jobSite" },
        { text: "Geofence", value: "geofence" },
      ],
      equipmentHashName: "",
      jobSiteRadioInput: "2",
      newJobSite: "",
      jobSiteId: null,
      // Read by the jobsite autocomplete's v-slot:selection "(+N more)" branch,
      // which only renders at index === 1. That autocomplete is not `multiple`,
      // so index is currently only ever 0 and the branch never runs — but the
      // identifier was previously undeclared, which would throw a TypeError the
      // moment `multiple` were added. Array to match Map.js, the multi-select
      // jobsite autocomplete this markup was copied from.
      selectedLocation: [],
      pageNumber: 1,
      pageSize: 52,
      totalRecords: 0,
      totalRecordsCount: 0,
      isContractsLoading: false,
      options: {},
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "52",
          count: 52,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      tempacccode: null,
      isFilter: false,
      isExcel: false,
      accessControlCodeDialog: false,
      unAssignConfirmationDivOpen: false,
      defaultAccessControlCode: "",
      defaultAccessControlCodeUnitId: "",
      isUnAssignedBtnSubmit: false,
      assignNewCodeDivOpen: false,
      accessKeysList: [],
      isGetAccessKeys: false,
      newAssignedCode: "",
      isAssignNewCodeBtnSubmit: false,
      createAssignNewCodeDivOpen: false,
      controlCodeFormValid: true,
      rules: rules,
      controlCodeName: "",
      controlCodeSerialNumber: "",
      keyValidList: [
        { name: "30Sec", value: "30Sec" },
        { name: "60Sec", value: "60Sec" },
        { name: "90Sec", value: "90Sec" },
      ],
      selectedKeyValid: "",
      keyExpireList: [
        { name: "0sec", value: "0sec" },
        { name: "15sec", value: "15sec" },
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "2min", value: "2min" },
        { name: "5min", value: "5min" },
        { name: "10min", value: "10min" },
        { name: "15min", value: "15min" },
        { name: "30min", value: "30min" },
        { name: "1hour", value: "1hour" },
        { name: "2hours", value: "2hours" },
        { name: "4hours", value: "4hours" },
        { name: "8hours", value: "8hours" },
        { name: "16hours", value: "16hours" },
      ],
      selectedKeyExpire: "",
      controlCodeNotes: "",
      isCreateAndAssignBtnSubmit: false,
      selectedAccessCodeCustomerId: "",
      selectedAccessCodeOwnerType: "2",
      accesscontrolDialogAsset: false,
      sortBy: "StockKey",
      sortOrder: "asc",
    };
  },
  computed: {
    ...mapGetters(["roles", "companyNameDropdown"]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.customerDataList.length
        : (this.pageNumber - 1) * this.pageSize + this.customerDataList.length;
    },
  },
  mounted() {
    // getting input content
    this.input = utils.getInputContent("birchFleet", this.roles);
    if (this.$route.query && this.$route.query.isFilter) {
      this.contractNumber = this.$route.query.serialNumber;
      this.isFilter = this.$route.query.isFilter;
    }
  },
  beforeDestroy() {
    //clear the stored toggleBtn Val on page destroy
    this.$store.dispatch("setActiveToggleVal", 0);
  },
  watch: {
    locationSearchFilter(val) {
      if (val != undefined && val != null) {
        return val.replace(/^\s+|\s+$/gm, "");
      }
    },
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  methods: {
    updateOptions(options) {
      let sortByColumn = options.sortBy[0];
      switch (sortByColumn) {
        case "accesscodesview":
          this.sortBy = "IsEnabled";
          break;
        case "EquipmentId":
          this.sortBy = "StockKey";
          break;
        case "customerEquipmentName":
          this.sortBy = "Name";
          break;
        case "serialNumber":
          this.sortBy = "SerialNumber";
          break;
        case "tuSerialNumber":
          this.sortBy = "TUSerialNumber";
          break;
        case "estimatedBatteryLifespan":
          this.sortBy = "EstimatedBatteryLifespan";
          break;
        case "hours":
          this.sortBy = "TotalHours";
          break;
        case "contractor":
          this.sortBy = "CustomerName";
          break;
        case "startDate":
          this.sortBy = "StartDate";
          break;
        case "endDate":
          this.sortBy = "EndDate";
          break;
        case "jobSite":
          this.sortBy = "JobSite";
          break;
        case "geofence":
          this.sortBy = "Geofence";
          break;
        default:
          this.sortBy = "StockKey";
          break;
      }
      this.sortOrder = options.sortDesc[0] ? "desc" : "asc";
      this.readDataFromApi();
    },
    radioInputChange() {
      if (this.jobSiteRadioInput == "1") {
        this.newJobSite = "";
      } else {
        this.jobSiteId = null;
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data
            .filter((e) => e.locationName != null)
            .map((item) => {
              return {
                locationName: item.locationName,
                locationId: item.locationId,
              };
            });
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
      }
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    datesCompare() {
      if (this.startDate && this.endDate) {
        let dateCheck =
          moment(this.endDate).format("YYYY-MM-DD") >=
          moment(this.startDate).format("YYYY-MM-DD");
        this.dateCheck = dateCheck;

        if (!this.dateCheck) {
          this.dateErrorMsg = "To Date should be greater than From Date";
          this.showdisable = true;
        }
      } else {
        this.dateCheck = false;
        this.showdisable = false;
      }
    },
    clearDates1() {
      if (this.startDate) {
        this.startDate = "";
      }

      this.dateErrorMsg = "";
      this.showdisable = false;
    },
    clearDates2() {
      if (this.endDate) {
        this.endDate = "";
      }
      this.dateErrorMsg = "";
      this.showdisable = false;
    },
    async editCustomerOwnedEquipment(item) {
      this.showCustDialog = true;
      this.contractor = item.contractor;
      this.equipmentId = item.equipmentId;
      this.description = item.description;
      this.equipmentHashName = item.name;
      this.customerEquipmentName = item.customerEquipmentName;
      if (item.startDate) {
        this.startDate = item.startDate;
      }
      if (item.endDate) {
        this.endDate = item.endDate;
      }
      this.datesCompare();
      await this.getLocations();
      if (item.jobSiteId != null && item.jobSiteId != "") {
        this.jobSiteRadioInput = "1";
        this.jobSiteId = this.locations.filter(
          (e) => e.locationId == item.jobSiteId
        )[0];
      } else {
        this.jobSiteRadioInput = "2";
        this.jobSiteId = null;
        this.newJobSite = item.jobSite;
      }
    },
    clearfields() {
      this.showCustDialog = false;
      this.contractor = "";
      this.equipmentId = "";
      this.jobSiteRadioInput = "2";
      this.startDate = "";
      this.endDate = "";
      this.description = "";
      this.customerEquipmentName = "";
      this.dateErrorMsg = "";
      this.dateCheck = false;
    },
    accessCodeClose(item) {
      this.tempacccode = item;
      this.openUnAssignConfirmation();
    },
    viewBirchDataDetails(id, equipId, assetId) {
      if (this.$route.query && this.$route.query.isFilter) {
        this.$router.push({
          name: "View Rental Equipment Details",
          params: { assetId: assetId },
          query: {
            serialNumber: this.contractNumber,
            isFilter: this.isFilter,
            navigateFrom: "Birch",
          },
        });
      } else {
        this.$router.push({
          name: "View Rental Equipment Details",
          params: { assetId: assetId },
          query: {
            serialNumber: "",
            isFilter: this.isFilter,
            navigateFrom: "Birch",
          },
        });
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.contractNumber = "";
      this.status = "";
      this.$router.replace(`/birch-fleet`);
      this.readDataFromApi();
    },

    pageChange() {
      this.readDataFromApi();
    },
    async readDataFromApi() {
      if (this.contractNumber) {
        this.isFilter = true;
        this.$router
          .replace(
            `/birch-fleet?serialNumber=${this.contractNumber}&isFilter=${this.isFilter}`
          )
          .catch(() => {});
      } else {
        this.isFilter = false;
        this.contractNumber = "";
        this.$router.replace(`/birch-fleet`).catch(() => {});
      }
      this.iscustomerDataLoading = true;
      this.customerDataList = [];
      let num = "";
      try {
        let response = await telematicsService.getBirchEquipmentList(
          num,
          this.fromDate,
          this.toDate,
          encodeURIComponent(this.contractNumber),
          this.pageNumber,
          this.pageSize,
          this.sortBy,
          this.sortOrder
        );
        if (response) {
          this.iscustomerDataLoading = false;
          this.customerDataList = response.data.map((d) => ({
            ...d,
            startDate: d.startDate ? d.startDate.split("T")[0] : "",
            endDate: d.endDate ? d.endDate.split("T")[0] : "",
          }));

          this.totalRecordsCount = response.totalRecords;

          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
        } else {
          this.iscustomerDataLoading = false;
          this.customerDataList = [];
        }
      } catch (err) {
        console.log(err);
        this.iscustomerDataLoading = false;
        this.customerDataList = [];
      }
    },
    async exportTableDataCust() {
      this.isExcel = true;
      let pageNumber = 1;
      let pageSize = -1;
      let num = "";
      this.excelListCust = [];
      try {
        let response = await telematicsService.getBirchEquipmentList(
          num,
          this.fromDate,
          this.toDate,
          this.contractNumber,
          pageNumber,
          pageSize,
          this.sortBy,
          this.sortOrder
        );
        if (response) {
          this.isExcel = false;
          let customerDataList = response.data;
          this.excelListCust = customerDataList.map((item) => {
            return {
              customerName: item.customerName ? item.customerName : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              name: item.name ? item.name : "",
              customerEquipmentName: item.customerEquipmentName
                ? item.customerEquipmentName
                : "",
              tuSerialNumber: item.tuSerialNumber ? item.tuSerialNumber : "",
              estimatedBatteryLifespan: item.estimatedBatteryLifespan
                ? item.estimatedBatteryLifespan
                : "",
              hours: item.hours ? item.hours : "",
              jobSite: item.jobSite ? item.jobSite : "",
              customerId:
                this.selectedCustomer != null
                  ? this.selectedCustomer["id"]
                  : "",
              contractor: item.contractor ? item.contractor : "",
              startDate: item.startDate ? item.startDate.split("T")[0] : "",
              endDate: item.endDate ? item.endDate.split("T")[0] : "",

              accessControlCods:
                item.accessCods.length != 0
                  ? item.accessCods.map((e) => e.accessControlCode).join()
                  : "",
              geofence: item.geofence ? item.geofence : "",
            };
          });
          this.excelHeaderCust = [];
          this.startrowCust = 3;
          this.excelHeaderCust.push(["Birch Fleet Data"]);
          this.startrowCust += 1;
          let cust;
          if (this.companyNameDropdown == "") {
            cust = "All";
          } else {
            cust = this.$store.getters.companyNameDropdown;
          }
          this.excelHeaderCust.push(["Customer:" + " " + cust]);
          for (const row of exportFilterRows) {
            if (this[row.field]) {
              this.startrowCust += 1;
              this.excelHeaderCust.push([row.label + " " + this[row.field]]);
            }
          }
          this.excelHeaderCust.push([]);
          this.startrowCust += 1;

          this.excelHeaderCust.push([
            "Equipment #",
            "Equipment Name",
            "Equipment SN",
            "Telematics SN",
            "Estimated Battery Lifespan (Days)",
            "Hours",
            "Customer Name",
            "Date Out",
            "Date Due",
            "Jobsite",
            "Geofence",
          ]);
          let tempExcel = this.excelListCust.map(function (item) {
            delete item.unitId;
            // hide accesscontrolcode
            delete item.accessControlCods;
            return item;
          });
          let datarow = "A" + this.startrowCust;
          var ws = XLSX.utils.aoa_to_sheet(this.excelHeaderCust);
          XLSX.utils.sheet_add_json(ws, tempExcel, {
            header: [
              "equipmentId",
              "customerEquipmentName",
              "serialNumber",
              "tuSerialNumber",
              "estimatedBatteryLifespan",
              "hours",
              "contractor",
              "startDate",
              "endDate",
              "jobSite",
              "geofence",
            ],
            skipHeader: true,
            origin: datarow,
          });
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Birch Equipment Data");
          this.excelHeaderCust = [];
          XLSX.writeFile(wb, "Birch Fleet Data.xlsx");
        } else {
          this.isExcel = false;
          this.excelListCust = [];
        }
      } catch (err) {
        console.log(err);
        this.isExcel = false;
        this.excelListCust = [];
      }
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 52;
      this.readDataFromApi();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 52;
      this.readDataFromApi();
    },
    // Update Access Control Code Functionalities
    openAccessControlDialog(item) {
      this.defaultAccessControlCode = "";
      this.defaultAccessControlCodeUnitId = "";
      this.selectedAccessCodeCustomerId = "";
      this.accessControlCodeDialog = true;
      this.defaultAccessControlCode = item.accessCods;
      this.defaultAccessControlCodeUnitId = item.tuUnitId;
      this.selectedAccessCodeCustomerId = item.customerId;
    },
    cancelAccessControlDialog() {
      this.accessControlCodeDialog = false;
      this.unAssignConfirmationDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.defaultAccessControlCode = "";
      this.defaultAccessControlCodeUnitId = "";
      this.selectedAccessCodeCustomerId = "";
      this.clearControlCodeFields();
    },
    // *---- First Btn UnAssign Code ------*
    clearControlCodeFields() {
      this.newAssignedCode = "";
      this.controlCodeName = "";
      this.controlCodeSerialNumber = "";
      this.selectedKeyExpire = "";
      this.selectedKeyValid = "";
      this.controlCodeNotes = "";
    },
    openUnAssignConfirmation() {
      this.unAssignConfirmationDivOpen = true;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelUnAssignConfirmation() {
      this.unAssignConfirmationDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.tempacccode = null;

      this.clearControlCodeFields();
    },
    // Put call unassign
    async unAssignControlCode() {
      this.isUnAssignedBtnSubmit = true;
      let payload = {
        id: this.tempacccode.accessControlKeyId,
        unitId: this.defaultAccessControlCodeUnitId,
        customerId: this.selectedAccessCodeCustomerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.unAssignAccessControlCode(
          payload
        );
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code is unassigned successfully."
          );
          this.isUnAssignedBtnSubmit = false;
          this.cancelUnAssignConfirmation();
          this.cancelAccessControlDialog();
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.isUnAssignedBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to unassign the access control code" + err);
        this.isUnAssignedBtnSubmit = false;
      }
    },
    // Assign New Code
    assignNewCodeDiv() {
      this.assignNewCodeDivOpen = true;
      this.getAccessKeysList();
      this.createAssignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelAssignNewCode() {
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.clearControlCodeFields();
    },
    async getAccessKeysList() {
      this.isGetAccessKeys = true;
      this.accessKeysList = [];
      try {
        let response = await telematicsService.getAccessKeysList(
          this.selectedAccessCodeCustomerId,
          this.selectedAccessCodeOwnerType
        );
        if (response && response.data) {
          this.isGetAccessKeys = false;
          let tempArrList = [];
          tempArrList = response.data.map(function (item) {
            return {
              companyName: item.companyName ? item.companyName : "",
              employeeNumber: item.employeeNumber ? item.employeeNumber : "",
              expirationDate: item.expirationDate ? item.expirationDate : "",
              id: item.id ? item.id : "",
              isAdmin: item.isAdmin ? item.isAdmin : "",
              keyExpire: item.keyExpire ? item.keyExpire : "",
              keyValid: item.keyValid ? item.keyValid : "",
              name: item.name ? item.name : "",
              note: item.note ? item.note : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              showCodeName:
                (item.serialNumber ? item.serialNumber + " - " : "") +
                (item.name ? item.name : ""),
            };
          });
          this.accessKeysList = tempArrList;
        } else {
          this.isGetAccessKeys = false;
          this.$toast.error("No access codes available");
          this.accessKeysList = [];
        }
      } catch (err) {
        this.isGetAccessKeys = false;
        console.log(err);
      }
    },
    // Put call update & assign
    async updateAndAssignNewCode() {
      this.isAssignNewCodeBtnSubmit = true;
      let payload = {
        id: this.newAssignedCode,
        unitId: this.defaultAccessControlCodeUnitId,
        customerId: this.selectedAccessCodeCustomerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.updateAndAssignNewCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "New access control code is assigned successfully."
          );
          this.isAssignNewCodeBtnSubmit = false;
          this.cancelAssignNewCode();
          this.cancelAccessControlDialog();
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.isAssignNewCodeBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to assign the new access control code" + err);
        this.isAssignNewCodeBtnSubmit = false;
      }
    },
    createAndAssignNewCodeDiv() {
      this.createAssignNewCodeDivOpen = true;
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelCreateAndAssignNewCodeDiv() {
      this.createAssignNewCodeDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    //Post Call Create & Assign
    async createAndAssignNewCode() {
      this.isCreateAndAssignBtnSubmit = true;
      let unitIdList = [];
      if (this.defaultAccessControlCodeUnitId) {
        unitIdList.push(this.defaultAccessControlCodeUnitId);
      } else {
        unitIdList = [];
      }
      let payload = {
        name: this.controlCodeName,
        serialNumber: this.controlCodeSerialNumber,
        keyValid: this.selectedKeyValid,
        keyExpire: this.selectedKeyExpire,
        note: this.controlCodeNotes,
        units: unitIdList,
        customerId: this.selectedAccessCodeCustomerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.createAndAssignNewCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code is created & assigned successfully."
          );
          this.isCreateAndAssignBtnSubmit = false;
          this.cancelCreateAndAssignNewCodeDiv();
          this.cancelAccessControlDialog();
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.isCreateAndAssignBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error(
          "Unable to create & assign the access control code" + err
        );
        this.isCreateAndAssignBtnSubmit = false;
      }
    },
    async updateCustomerOwnedDetails() {
      this.editCustomerOwnedEquipmentDetails = true;
      let payload = {
        equipmentId: this.equipmentId,
        contractor: this.contractor,
        jobSiteId:
          this.jobSiteId != null && this.jobSiteId != ""
            ? this.jobSiteId["locationId"]
            : null,
        jobSite:
          this.jobSiteId != null && this.jobSiteId != ""
            ? this.jobSiteId["locationName"]
            : this.newJobSite,
        description: this.description,
        customerEquipmentName: this.customerEquipmentName,
        startDate: this.startDate == "" ? null : this.startDate,
        endDate: this.endDate == "" ? null : this.endDate,
      };
      try {
        let response = await telematicsService.updateCustomerOwnedDetails(
          payload
        );
        if (response.isSuccess) {
          this.$toast.success("Updated Birch Fleet Details successfully.");
          this.editCustomerOwnedEquipmentDetails = false;
          this.showCustDialog = false;
          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.editCustomerOwnedEquipmentDetails = false;
        }
      } catch (err) {
        this.$toast.error("Unable to Update Birch Fleet Details " + err);

        this.editCustomerOwnedEquipmentDetails = false;
      }
    },
    async UpdateLockUnlockAccessCodes() {
      this.isconfirm = true;
      try {
        let response = await telematicsService.updateLockUnlockAccessCodes(
          this.assetIdNew,
          !this.isLockednew
        );
        if (response.isSuccess) {
          this.$toast.success("Access control has been updated");
          this.confirmaccessdialog = false;
          this.isconfirm = false;

          this.readDataFromApi();
        } else {
          this.$toast.error(response.systemMessage);
          this.confirmaccessdialog = false;
          this.isconfirm = false;
        }
      } catch (err) {
        this.$toast.error("Unable to Access control " + err);

        this.confirmaccessdialog = false;
      }
    },
    async ConfirmLockUnlockAccessCodes(assetIdNew, isLockednew) {
      this.assetIdNew = assetIdNew;
      this.isLockednew = isLockednew;
      this.confirmaccessdialog = true;
    },
    cancelAccessControlDialogAsset() {
      this.controlCodeSerialNumber = "";
      this.name = "";
      this.enableDisableAccess = false;
      this.isEditAccess = false;
      this.displayAccessForm = false;
    },
    closeAccessControlDialogAsset() {
      this.cancelAccessControlDialogAsset();
      this.accesscontrolDialogAsset = false;
    },
    async viewAccessCodeAssets(customerId, customerName, assetId) {
      this.accesscontrolDialogAsset = true;
      this.selectedAccessAssetCustId = customerId;
      this.selectedAccessAssetCustName = customerName;
      this.selectedAssetId = assetId;

      try {
        this.iscustomerDataLoading = true;
        const response = await telematicsService.getAccessCodesByAssets(
          customerId,
          assetId
        );
        if (response.isSuccess) {
          this.accessCodesList = response.data;
          this.iscustomerDataLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.iscustomerDataLoading = false;
      }
    },
    async saveAccessKeys() {
      this.accessKeysLoading = true;
      try {
        let payload = {
          code:
            this.enableDisableAccess == true
              ? this.controlCodeSerialNumber
              : "",
          description: this.enableDisableAccess == true ? this.name : "",
          isEnabled: this.enableDisableAccess,
          masterKeyType: "PRIVATE_KEY",
          assetIds: this.selectedAssetId,
          customerId: this.selectedAccessAssetCustId,
          customerName: this.selectedAccessAssetCustName,
        };
        let response = await telematicsService.saveAccessKeys(payload);
        if (response) {
          this.$toast.success(response.systemMessage);
          this.viewAccessCodeAssets(
            this.selectedAccessAssetCustId,
            this.selectedAccessAssetCustName,
            this.selectedAssetId
          );
          this.accessKeysLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.accessKeysLoading = false;
      }
    },
    async updateAccessKeys() {
      this.accessKeysLoading = true;
      try {
        let payload = {
          code:
            this.enableDisableAccess == true
              ? this.controlCodeSerialNumber
              : "",
          description: this.enableDisableAccess == true ? this.name : "",
          assetIds: this.selectedAssetId,

          masterKeyType: "PRIVATE_KEY",
          isEnabled: this.enableDisableAccess,

          customerId: this.selectedAccessAssetCustId,
          customerName: this.selectedAccessAssetCustName,
        };

        let response = await telematicsService.updateAccessKeys(
          this.itemid,
          payload
        );
        if (response) {
          this.$toast.success(response.systemMessage);
          this.accessKeysLoading = false;
          this.viewAccessCodeAssets(
            this.selectedAccessAssetCustId,
            this.selectedAccessAssetCustName,
            this.selectedAssetId
          );
        }
      } catch (err) {
        console.log(err);
        this.accessKeysLoading = false;
      }
    },
    showAccessData() {
      this.displayAccessForm = true;
    },
    EditAccessDialog(item) {
      this.isEditAccess = true;
      this.displayAccessForm = true;
      this.controlCodeSerialNumber = item.code;
      this.enableDisableAccess =
        item.code != "" && item.code != null ? true : false;
      this.name = item.description;
      this.itemid = item.id;
    },
  },
};
